import { NextIcon } from 'foundations-assets';
import { Flex } from 'foundations-components/components/Flex';
import { Box } from 'foundations-components/transitional/components/Box';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const EmptyStateListItem = ({
  content
}) => /*#__PURE__*/_jsxs(Flex, {
  alignItems: "baseline",
  marginBlockEnd: "400",
  children: [/*#__PURE__*/_jsx(Box, {
    basis: 20,
    shrink: 0,
    marginInlineEnd: "300",
    children: /*#__PURE__*/_jsx(Flex, {
      justifyContent: "center",
      alignItems: "center",
      children: /*#__PURE__*/_jsx(NextIcon, {})
    })
  }), /*#__PURE__*/_jsx("span", {
    children: content
  })]
});
export default EmptyStateListItem;